import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumb } from "@faire/retailer-visitor-shared/components/Breadcrumb/index";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";
export var ProductBreadcrumbs = function(param) {
    var product = param.product, breadcrumbOptions = param.breadcrumbOptions;
    var options = breadcrumbOptions.slice();
    if (product === null || product === void 0 ? void 0 : product.name) {
        var _product_name_translated, _ref;
        options.push({
            label: (_ref = (_product_name_translated = product.name.translated) !== null && _product_name_translated !== void 0 ? _product_name_translated : product.name.original) !== null && _ref !== void 0 ? _ref : ""
        });
    }
    return /*#__PURE__*/ _jsxs(TabletAndAbove, {
        children: [
            /*#__PURE__*/ _jsx(Breadcrumb, {
                options: options,
                horizontalPadding: "0"
            }),
            /*#__PURE__*/ _jsx(HorizontalLine, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "5x"
            })
        ]
    });
};
var TabletAndAbove = styled.div.withConfig({
    componentId: "sc-6f7273e1-0"
})([
    "",
    "{display:none;}"
], responsiveMediaQueries.mobile);
